module.exports = __webpack_public_path__ + "media/customizations/brighton/logo-065ae8968b042986d47c7ee5b6d6838b.png";